import { render, staticRenderFns } from "./IconSupplies.vue?vue&type=template&id=dbc02788&"
import script from "./IconSupplies.vue?vue&type=script&lang=js&"
export * from "./IconSupplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports